import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import { regexName } from "../../../../../../../util/regularExpress";
import { setPrevState } from "../../../../../../../util/common";
import { JOBS } from "../../../../utils/JobData";
import { useSelector } from "react-redux";
function NamePanel(props) {
  const { state, setState } = props;
  const { editJob } = useSelector((state) => state.dataPipeline);

  const jobType = useMemo(() => Number(editJob?.data?.type || 1), [editJob?.data?.type]);

  const handleStateChange = useCallback(
    (key, value) => {
      if (key === "name") {
        const isValid = regexName(value, "jobName", "_ -");
        if (isValid) setPrevState(setState, { [key]: value });
      } else setPrevState(setState, { [key]: value });
    },
    [setState]
  );

  return (
    <Grid container direction={"row"} spacing={2}>
      <Grid sx={{ width: { xs: "100%", sm: "300px" } }}>
        <TextField
          fullWidth
          required
          label="Job Name"
          inputProps={{ maxLength: 30 }}
          value={state?.name || ""}
          onChange={(e) => handleStateChange("name", e.target.value)}
        />
      </Grid>
      <Grid sx={{ width: { xs: "100%", sm: "300px" } }}>
        <TextField select required fullWidth variant="outlined" label="Job Type" disabled value={jobType}>
          {JOBS.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.Name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={12}></Grid>
      <Grid sx={{ width: { xs: "100%", sm: "900px" } }}>
        <TextField
          placeholder="Job Description"
          fullWidth
          multiline
          rows={5}
          value={state?.description || ""}
          onChange={(e) => handleStateChange("description", e.target.value)}
        />
      </Grid>
    </Grid>
  );
}

NamePanel.propTypes = {
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
};

export default React.memo(NamePanel);
